export default "__VITE_ASSET__$HDoUByStEEEQIDccC83eQ__"